import React, { createContext, useContext, useEffect } from 'react'
import useGetCompanyInfo from '../Hooks/useGetCompanyInfo'

const CompanyInfoContext = createContext();

export const useCompanyInfo = () => {
  return useContext(CompanyInfoContext);
}

export const CompanyInfoProvider = ({ children }) => {

  const { footerData, companyInfoData, navBarItems, loadingData } = useGetCompanyInfo()

  return (
    <CompanyInfoContext.Provider value={{ footerData, companyInfoData, navBarItems, loadingData }}>
      {children}
    </CompanyInfoContext.Provider>
  )
}
